import loadable from '@loadable/component';
import { Loading } from '../../components/Mobile';

export const OffersHistoryContentLoadable = loadable(() => import('./OffersHistoryContentContainer'), {
  fallback: <Loading />,
  resolveComponent: ({ OffersHistoryContentContainer }) => OffersHistoryContentContainer,
});
